// src/components/products/ProductForm/Step2ProductDetails.jsx

import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import TransferDetails from "./TransferDetails";
import TourDetails from "./TourDetails";
import NotFoundType from "./NotFoundType";

/**
 * Step 2: Product-Specific Details (Transfer or Tour)
 * Renders different form based on product type
 */
const Step2ProductDetails = ({ formData, setFormData, errors = {} }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    // Determine product type
    const productType = formData.selectedProductType;
    const productTypeName = productType?.name?.en || productType?.name || '';

    const isTransfer = productTypeName.toLowerCase().includes('transfer');
    const isTour = productTypeName.toLowerCase().includes('tour');

    // If no product type selected yet
    if (!productType) {
        return (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary">
                    {isArabic
                        ? 'الرجاء اختيار نوع المنتج أولاً'
                        : 'Please select a product type first'}
                </Typography>
            </Paper>
        );
    }

    return (
        <Box>
            {/* Transfer Details */}
            {isTransfer && (
                <TransferDetails
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors}
                />
            )}

            {/* Tour Details */}
            {isTour && (
                <TourDetails
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors}
                />
            )}

            {/* If product type doesn't match Transfer or Tour */}
            {!isTransfer && !isTour && (
                <NotFoundType productTypeName={productTypeName} />
            )}
        </Box>
    );
};

export default Step2ProductDetails;
